export enum HandoverOutpostType {
  DELIVERY = 'Delivery',
  RETURN = 'Return',
}

export const EXCLUSION_ZONE_TYPE = 'handover_outpost';
